import React, { useEffect } from "react";

import TopBar from "../Common/TopBar";
import AndroidService from "../../Services/AndroidService";
import AnalyticsService from "../../Services/AnalyticsService";
import getCropBasedPGLink from "../../Services/CropBasedProductGroup";
import EmptyError from "../EmptyError/EmptyError";

export default function CropBasedProductGroup() {
  const cropBasedPGLink = getCropBasedPGLink();
  useEffect(() => {
    AnalyticsService.pushEvent("Page Viewed", {
      page: window.location.pathname,
    });

    AndroidService.unsetPullToRefresh();
    return () => AndroidService.setPullToRefresh();
  }, []);

  return (
    <div>
      <TopBar title="Crop Based Product Group" backNavigation={true} />

      {cropBasedPGLink ? (
        <embed
          type="application/xml"
          src={cropBasedPGLink}
          width="100%"
          height={window.innerHeight - 56 + 6}
        />
      ) : (
        <EmptyError
          image="EmptyPage.svg"
          text="Report not available in your state!"
        />
      )}
    </div>
  );
}
